import { useMemo } from "react";
import type { StartedRun } from "@/features/credentials/components/primary-source-runs/types";
import { WorkspaceStartVerificationDialog } from "./psv-launch/workspace-start-verification-dialog";
import { useShowStartedRun } from "./use-provider-page-navigation";
import type { WorkspaceProvider } from "./workspace-types";

/** The start-verification dialog for one roster provider; starting a run
 * opens that provider's page on the new run. */
export function ProviderStartVerification({
  provider,
  organizationBusinessUnitId,
  onClose,
  onRestoreFocus,
}: {
  provider: Pick<WorkspaceProvider, "affiliationId" | "providerUserId">;
  organizationBusinessUnitId: string;
  onClose: () => void;
  onRestoreFocus: () => void;
}) {
  const { affiliationId, providerUserId } = provider;
  const scope = useMemo(
    () => ({
      organizationBusinessUnitId,
      providerUserId,
      expectedAffiliationId: affiliationId,
    }),
    [organizationBusinessUnitId, providerUserId, affiliationId],
  );
  const showStartedRun = useShowStartedRun({ scope, affiliationId });
  const onStarted = async (request: StartedRun) => {
    await showStartedRun(request);
    onClose();
  };
  return (
    <WorkspaceStartVerificationDialog
      scope={scope}
      onClose={onClose}
      onStarted={onStarted}
      onRestoreFocus={onRestoreFocus}
    />
  );
}
